import styled from 'styled-components';
import { useDispatch, useSelector } from 'src/store/store';
import Button from 'src/components/buttons/button';
import { showModal } from 'src/modules/shared/modal/actions';
import i18n from 'src/utils/translate';
import { helpScoutArticle } from 'src/utils/helpScoutBeacon';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section, Origin } from 'src/constants/footfall';
import { ModalType } from 'src/constants/modalTypes';
import PrivacySection from 'src/modules/community/write/components/writePostPrivacySection';
import { addExcludedTag } from 'src/modules/community/write/actions';
import { AddButton, StyledIconButton } from 'src/modules/community/write/components/sharedStyles';
export default function PostExtras(): JSX.Element {
  const dispatch = useDispatch();
  const {
    selectedTopic,
    tags,
    post
  } = useSelector(state => state.pages.write);
  const showTopicsModal = () => {
    dispatch(showModal({
      modalType: ModalType.ChooseTopic
    }));
  };
  const excludeTag = (entityId: number) => {
    dispatch(addExcludedTag(entityId));
    trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.SuggestedTags,
        origin: post?.id ? Origin.EditPostPage : Origin.WritePostPage
      },
      clickType: 'exclude-tag'
    });
  };
  const showSuggestedTagsInfo = () => {
    helpScoutArticle('192-suggested-tags');
    trackFootfallEvent(Event.Clicked, {
      clickMetadata: {
        section: Section.SuggestedTagsInfo,
        origin: post?.id ? Origin.EditPostPage : Origin.WritePostPage
      },
      clickType: 'viewed'
    });
  };
  return <Wrapper data-sentry-element="Wrapper" data-sentry-component="PostExtras" data-sentry-source-file="writePostExtras.tsx">
      {!selectedTopic ? <AddTopicButton dataTestId="add-topic-button" icon="plus" text={i18n.t('Add topic')} type="link" onClick={showTopicsModal} /> : <TopicWrapper>
            {i18n.t('Topic')}:
            <TopicTag ariaLabel={i18n.t('Change Topic')} dataTestId="change-topic-button" icon="cross" iconPosition="right" text={selectedTopic.name} type="link" onClick={showTopicsModal} />
          </TopicWrapper>}
      {!!tags?.length && <SuggestedTagsWrapper>
          <Title>
            {i18n.t('Suggested Tags')}
            <StyledIconButton ariaLabel={i18n.t('What are suggested tags?')} icon="information" type="link" onClick={showSuggestedTagsInfo} />
          </Title>
          <TagsWrapper>
            {tags.map(tag => <Button dataTestId="suggested-tag-button" icon="cross" iconPosition="right" key={tag.entityId} text={tag.shortName} type="tag" onClick={() => excludeTag(tag.entityId)} />)}
          </TagsWrapper>
        </SuggestedTagsWrapper>}
      <PrivacySection data-sentry-element="PrivacySection" data-sentry-source-file="writePostExtras.tsx" />
    </Wrapper>;
}
const Wrapper = styled.div`
  padding: 15px 0 20px;
`;
const TopicWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-bottom: 15px;
  color: ${({
  theme
}) => theme.colorTextLight};
`;
const SuggestedTagsWrapper = styled.div`
  padding: 0 10px 10px;
  border: ${({
  theme
}) => theme.greyLine};
  border-radius: 4px;
`;
const AddTopicButton = styled(AddButton)`
  margin-bottom: 15px;
  color: ${({
  theme
}) => theme.colorTextLight};
`;
const TopicTag = styled(Button)`
  color: ${({
  theme
}) => theme.colorTextLight};
  margin: 0 0 0 5px;
`;
const Title = styled.div`
  display: flex;
  gap: 5px;
  padding: 10px 0 10px;
  padding-bottom: 5px;
  color: ${({
  theme
}) => theme.colorTextLight};
`;
const TagsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;